import React, { Component } from 'react';

class IconInfo extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="14.657" height="14.657" viewBox="0 0 14.657 14.657"><path className="a" d="M10.329,3a7.329,7.329,0,1,0,7.329,7.329A7.331,7.331,0,0,0,10.329,3Zm.733,10.993H9.6V9.6h1.466Zm0-5.863H9.6V6.664h1.466Z" transform="translate(-3 -3)" fill="#164b90" /></svg>
        );
    }
}

export default IconInfo;